import { Card, CardContent, Typography } from "@mui/material";

export const UnknownStatus = () => {
    return (

        <Card>
            <CardContent>

                <Typography>
                    Status not recognized. no actions are available.
                </Typography>

            </CardContent>
        </Card>
    );
}